export const zeroPad = (num: number): string => {
  return `${num < 10 ? '0' : ''}${num}`;
};

export const secondsToTimestamp = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / (60 * 60));
  const minutes = Math.floor((totalSeconds / 60) % 60);
  const seconds = totalSeconds % 60;
  return `${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds).substr(0, 6)}`;
};

/* Remove objects with duplicate key property in arr. Lower index wins. */
export const removeDuplicates = (key: string, arr: Array<any>) => {
  const seen = new Set<string>();
  return arr.filter((obj) => {
    if (key in obj && !seen.has(obj[key])) {
      seen.add(obj[key]);
      return true;
    }
    return false;
  });
};

/* Returns Promise as data URL */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    try {
      const reader: FileReader = new FileReader();
      reader.addEventListener('load', () => {
        if (reader) {
          const content = reader.result as string;
          resolve(content);
        }
      });
      reader.readAsDataURL(file);
    } catch (e) {
      reject(e);
    }
  });
};

/* Convert a file Blob to a ArrayBuffer */
export const fileToArrayBuffer = (file: File): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    try {
      const reader: FileReader = new FileReader();
      reader.addEventListener('load', () => {
        if (reader) {
          const content = reader.result as ArrayBuffer;
          resolve(content);
        }
      });
      reader.readAsArrayBuffer(file);
    } catch (e) {
      reject(e);
    }
  });
};

export const betweenOrEqual = (start: number, num: number, end: number) => {
  return num >= start && num < end;
};

export const secondsToString = (seconds: number): string => {
  const modifier = seconds < 3600 ? 3 : 0;
  try {
    const value = new Date(seconds * 1000).toISOString().substr(11 + modifier, 8 - modifier);
    return value;
  } catch (error) {
    console.debug('error converting seconds to string');
    console.debug(seconds);
    return '';
  }
};

export function deepEqual(a: any, b: any) {
  if (typeof a == 'object' && a !== null && typeof b == 'object' && b !== null) {
    const count = [0, 0];
    let key: string | number;
    for (key in a) count[0]++;
    for (key in b) count[1]++;
    if (count[0] - count[1] !== 0) {
      return false;
    }
    for (key in a) {
      if (!(key in b) || !deepEqual(a[key], b[key])) {
        return false;
      }
    }
    for (key in b) {
      if (!(key in a) || !deepEqual(b[key], a[key])) {
        return false;
      }
    }
    return true;
  } else {
    return a === b;
  }
}
